import { atom } from "recoil";
import { CustomerStatus } from "../services";

export const CustomerFilterState = atom<CustomerStatus | null>({
  key: "customerFilterState",
  default: undefined,
});
